import { privateClientSetup } from './private-client-setup'
import { publicClientSetup } from './public-client-setup'

export const publicRequestV1 = publicClientSetup('v1')
export const publicRequestV2 = publicClientSetup('v2')
export const privateRequestV1 = privateClientSetup('v1')
export const privateRequestV2 = privateClientSetup('v2')
